var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrEnd"},[_c('p',{staticClass:"ln1"},[_vm._v("Спасибо!")]),_c('p',{staticClass:"ln2"},[_vm._v("Мы приняли Вашу заявку.")]),_c('p',{staticClass:"ln3"},[_vm._v("Наша системы начал проверку данных. В течение 15 минут с Вами свяжется наш специалист для дальнейших действий. ")])])
}]

export { render, staticRenderFns }